<template>
  <section class="content_section">
    <SimpleList v-if="isLoaded" :serverside="false" @filter="getFiltered"
                :tripsSource="'getAllTrips'"
                :data="trips" :options="options" :title=options.Lang.Aktive_Vorgänge :defaultCount="defaultCount" :cols="cols" :hideCols="hideCols"
                :emptyState=options.Lang.Keine_Vorgänge_vorhanden :buttonText=options.Lang.Neuen_Vorgang_anlegen buttonAction="ImportTrip"
                :actions="filteredActions" :clean="false" :offerLink="true" @updateData="getAll()"></SimpleList>
    <FormClient @updateData="getAll()" v-if="options.showClientForm && options.user.loggedIn" :currentClient="options.currentClient" :options="options"></FormClient>
    <FormUser @updateData="getAll()" v-if="options.showUserForm && options.user.loggedIn" :currentFormUser="options.currentFormUser" :options="options"></FormUser>
    <FormImportTrip @updateData="getAll()" v-if="options.showImportTripForm && options.user.loggedIn" :currentTrip="options.currentTrip" :options="options"></FormImportTrip>
    <FormUploadPdf @updateData="getAll()" v-if="options.showUploadPdfForm && options.user.loggedIn" :currentTrip="options.currentTrip" :options="options"></FormUploadPdf>
    <FormSendEmailToSupplier @updateData="getAll()" v-if="options.showSendEmailToSupplierForm && options.user.loggedIn" :currentTrip="options.currentTrip" :options="options"></FormSendEmailToSupplier>
    <FormTimeline @updateData="getAll()" v-if="options.showTimelineForm && options.user.loggedIn" :currentTrip="options.currentTrip" :options="options"></FormTimeline>
    <FormFirstImage @updateData="getAll()" v-if="options.showFirstImageForm && options.user.loggedIn" :currentTrip="options.currentTrip" :options="options"></FormFirstImage>
    <FormCustomerLogin @updateData="getAll()" v-if="options.showCustomerLoginForm && options.user.loggedIn" :currentTrip="options.currentTrip" :options="options"></FormCustomerLogin>
    <FormEditHello @updateData="getAll()" v-if="options.showEditHelloForm && options.user.loggedIn" :currentTrip="options.currentTrip" :options="options"></FormEditHello>
    <FormAddKommentar @updateData="getAll()" v-if="options.showaddKommentarForm && options.user.loggedIn" :currentTrip="options.currentTrip" :options="options"></FormAddKommentar>
    <div v-if="showAlert" id="alertBox" class="md-elevation-11">
      <div style="padding: 40px;">
        <label>Nachricht vom: {{ alert.alertMessage.datum }}</label>
        <div style="height: 100%; display: flex; flex-direction: column; justify-content: space-between;">
          <p v-html="alert.alertMessage.nachricht">

</p>
<md-button @click="updateSeeAlertStatus()" class="md-raised md-primary" style="width: 200px; margin-left: auto; margin-right: auto;" >Bestätigen</md-button>
        </div>
       
      </div>
    </div>
  </section>
</template>
<script>

import SimpleList from "@/components/lists/SimpleList";
import FormUser from "@/components/dialogs/FormUser";
import FormClient from "@/components/dialogs/FormClient";
import FormSendEmailToSupplier from "@/components/dialogs/FormSendTripToSupplier";
import FormImportTrip from "@/components/dialogs/FormImportTrip";
import FormUploadPdf from "@/components/dialogs/FormUploadPdf";
import FormTimeline from "@/components/dialogs/FormTimeline";
import FormEditHello from "@/components/dialogs/FormEditHello";
import FormFirstImage from "@/components/dialogs/FormFirstImage";
import FormCustomerLogin from "@/components/dialogs/FormCustomerLogin";
import * as moment from 'moment'
import FormAddKommentar from "../../components/dialogs/FormAddKommentar.vue";

export default {
  name: 'trips',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  components: {
    SimpleList,
    FormClient,
    FormUser,
    FormImportTrip,
    FormSendEmailToSupplier,
    FormUploadPdf,
    FormEditHello,
    FormTimeline,
    FormFirstImage,
    FormCustomerLogin,
    FormAddKommentar
},
  data() {
    return {
      userSeeStatus: null,
      showAlert: false,
      alert: [],
      imgs: [],
      defaultCount: null,
      search: null,
      searchedTrips: [],
      selectedTrips: [],
      trips: [],
      hideCols: ['loginCode', 'trip_details', 'trip_details_en', 'lastLoginTime','firstname', 'agency', 'lastname', 'sales_firstname', 'sales_lastname', 'date_start', 'date_end', 'done', 'titelimg', 'json_path', 'timestampCustomerMail', 'branding_id'],
      cols: ['offer_id', 'loginCode', 'nezasa_id', 'json_path','client_name', 'sales_name', 'lastLoginTime', 'timestampCustomerMail', 'agency', 'trip_details', 'trip_details_en', 'firstname', 'lastname', 'sales_firstname', 'sales_lastname', 'date_start', 'date_end', 'trip_date', 'Branding', 'titelimg', 'booking_state', 'branding_id'],
      isLoaded: false,
      actions: [
        {
          icon: 'update.svg',
          action: 'updateTrip',
          title: this.options.Lang.reimport,
          svg:true
        },
        {
          text: "  |  "
        },
        {
          icon: 'addImage.png',
          action: 'uploadFirstImage',
          iconMaterial: true,
          title: this.options.Lang.Titelbild_hochladen,
          svg: true
        },

        {
          icon: 'pdf.png',
          iconMaterial: true,
          action: 'uploadData', 
          title: this.options.Lang.Daten_hochladen,
          svg: true
        },
        {
          text: "  |  "
        },
        {
          icon: 'password.png',
          iconMaterial: true,
          action: 'customerLogin',
          title: this.options.Lang.Zugangsdaten_an_Kunden_schicken,
          svg: true,
          greenCheckColumn: 'timestampCustomerMail'
        },
        {
          icon: 'preview.png',
          greenIcon: 'preview-green.svg',
          iconMaterial: true,
          action: 'reviewTrip',
          title: this.options.Lang.Vorschau_für_Angebot,
          svg: true,
          greenCheckColumn: 'lastLoginTime'
        },
        {
          icon: 'archive.png',
          action: 'archivTrip',
          title: this.options.Lang.Vorgang_archivieren,
          svg: true
        },
      ],
    };
  },
  beforeCreate() {
  },
  beforeMount() {
  },
  async created() {
    this.options.isUploading = true;
    await this.getCurrentUser();
    await this.getAllImg();
    await this.getAll();
  },
  async mounted() {
    await this.getCurrentUser();
    await this.getAllImg();
    await this.getAll();
    let self = this;
    self.defaultCount = self.options.defaultCount;

    if (self.options.currentRoute !== 'Brandings') {
      self.options.showBrandForm = false;
    }

    await self.getSeeAlertStatus();
    await self.getAlertMessage();
    self.autoLaunchImport();
  },
  computed: {
    filteredActions() {
      return this.actions;
    }
  },
  watch: {
    '$route'(to, from) {
      if (to.name === 'Trips') {
        this.getAll(); // or whatever method loads your trip data
      }
    }
  },
  methods: {
    async getAlertMessage(){
      let self = this;
      await this.doPost({}, 'getAlertMessage', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data[0]
          self.alert.alertMessage = result
          self.alert.booleanAlert = result.status !== "false"
          self.alert.booleanTest = result.test !== "false"
          self.alert.date = result.datum
        }
      });
      if(self.options.user.supersuper === 1){
        if(self.alert.booleanTest === true){
          self.showAlert = true;
        }
      }
      if(self.options.user.supersuper === 0){
        if(self.alert.booleanAlert === true && self.userSeeStatus === "false"){
          //alert("test")
          self.showAlert = true;
        }
      }
    },
    async updateSeeAlertStatus(){
      let self = this;
      await self.doPost({ data: self.options.user }, 'updateSeeAlertStatus', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.showAlert = false;
        }
      });
      await self.getSeeAlertStatus();
    },
    async getSeeAlertStatus(){
      let self = this;
      self.doPost({ data: self.options.user }, 'getSeeAlertStatus', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data;
          self.userSeeStatus = res.data.data[0].seeAlert;
        }
      });
    },
    async getAllImg() {
      let self = this;
      self.imgs = [];
      await this.doPost({data: 'tripId'}, 'getFirstImages', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data;
          for (let i = 0; i < result.length; i++) {
            self.imgs.push(result[i]);
          }

        }
      });
      this.options.isUploading = false;
    },
    async getAll() {
      let self = this;
      let countFrom = sessionStorage.getItem('trip_count') || "0";
      self.isLoaded = false;
      self.options.isUploading = true;
      await this.doPost({
        userdata: self.options.user,
        data: {count: parseInt(countFrom)}
      }, 'getAllTrips', async res => {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.responseToTableData(res.data.data, self.cols).then(values => {
            self.trips = values;
            const count = self.trips.length;
            for (let i = 0; i < count; i++) {
              self.trips[i].trip_date = moment(self.trips[i].date_start).format('DD MMM YYYY') + ' - ' + moment(self.trips[i].date_end).format('DD MMM YYYY')
              if( self.trips[i].Branding === "" || self.trips[i].Branding === "null" || self.trips[i].Branding == null ){
                self.trips[i].Branding = "---"
              }
              self.searchedTrips.push(self.trips[i])
            }
          })
        }
        self.options.isUploading = false;
        if (self.options.ModulSuppliermail) {
          const sendSupplierExists = self.actions.some(item => item.action === 'sendSupplier');
          if (!sendSupplierExists) {
            self.actions.splice(2, 0, {
              icon: 'supplier.png',
              action: 'sendSupplier',
              title: self.options.Lang.Email_an_Supplier_versenden,
              svg: true
            }, {text: "  |  "})
          }
        }
        if (self.options.ModulHelloEdit) {
          const sendHelloEx = self.actions.some(item => item.action === 'editHello');
          if (self.options.ModulSuppliermail) {
            if (!sendHelloEx) {
              self.actions.splice(5, 0, {
                icon: 'editPaper.png',
                iconMaterial: true,
                action: 'editHello',
                title: self.options.Lang.editHello,
                svg: true
              })
            }
          } else {
            if (!sendHelloEx) {
              self.actions.splice(1, 0, {
                icon: 'editPaper.png',
                iconMaterial: true,
                action: 'editHello',
                title: self.options.Lang.editHello,
                svg: true
              })
            }

          }
          if (self.options.ModulKommentare) {
            const Kommentare = self.actions.some(item => item.action === 'addKommentar');
            if (self.options.ModulSuppliermail) {
              if (!Kommentare) {
                self.actions.splice(6, 0, {
                  icon: 'comment.svg',
                  iconMaterial: true,
                  action: 'addKommentar',
                  title: self.options.Lang.addKommentare,
                  svg: true
                })
              }
            } else {
              if (!Kommentare) {
                self.actions.splice(2, 0, {
                  icon: 'comment.svg',
                  iconMaterial: true,
                  action: 'addKommentar',
                  title: self.options.Lang.addKommentare,
                  svg: true
                })
              }
            }
          }
        }
        this.actions = [...this.actions]; // clone triggers reactivity
        const search_text = sessionStorage.getItem('trip_search')
        if (search_text) {
          await self.searchDataForTrips()
        }
        window.setTimeout(function () {
          self.isLoaded = true;
        }, 500)

      });
    },
    async searchDataForTrips(){
      await this.getAllBrandings();
      let self = this;
      self.isLoaded = false;
      self.options.isUploading = true;
      self.searched = [];
      await this.doPost({
        userdata: self.options.user, data: {
          search: self.search,
        }
      }, 'searchAllTrips', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          if (res.data.data && (typeof res.data.data === 'object' || Array.isArray(res.data.data))) {
            self.responseToTableData(res.data.data, self.cols).then(values => {
              self.trips = values;
              const count = self.trips.length;
              for (let i = 0; i < count; i++) {
                self.trips[i].trip_date = moment(self.trips[i].date_start).format('DD MMM YYYY') + ' - ' + moment(self.trips[i].date_end).format('DD MMM YYYY')
                if (self.trips[i].Branding === "" || self.trips[i].Branding === "null" || self.trips[i].Branding == null) {
                  self.trips[i].Branding = "---"
                }
                self.matchedBrand.forEach(matchBrand => {
                  if (matchBrand.name === self.trips[i].Branding) {
                    self.searched.push(self.trips[i])
                  }
                })
              }
              self.customOrderAfterMoreData();
            })
          }
        }
        self.options.isUploading = false;
      })
    },
    async customOrderAfterMoreData(){
      if (this.currentSort && this.currentSortOrder) {
        this.searched.sort((a, b) => {
          let comparison = 0;
          if (a[this.currentSort] > b[this.currentSort]) {
            comparison = 1;
          }else if (a[this.currentSort] < b[this.currentSort]) {
            comparison = -1;
          }
          return this.currentSortOrder === 'desc' ? comparison : comparison * -1;
        });
      }
    },
    async getAllBrandings() {
      this.brandings = [];
      this.allowedUserBranding = [];
      let self = this;
      await self.doPost({}, 'getAllBranding', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data;
          for(let i = 0; i < result.length; i++){
            self.brandings.push(result[i])
          }
        }
      });
      self.allowedUserBranding = JSON.parse(self.options.user.brandings);
      this.filterBrandings();
    },
    filterBrandings() {
      this.matchedBrand = [];
      this.brandings.forEach(branding => {
        let allowed = this.allowedUserBranding.find(brand => brand === branding.id)
        if(allowed) {
          let brandDetails = {
            name: branding.adresse,
            brandingID: branding.id
          }
          this.matchedBrand.push(brandDetails);
        }
      });
    },
    getFiltered(args) {
      let self = this;
      self.options.isUploading = true;
      let where = args && args.where ? args.where : null;
      let order = args && args.order ? args.order : null;
      this.doPost({
        userdata: self.options.user,
        data: {
          where: where,
          sort: order
        },
        brandings: self.$store.getters.getUser.brandings
      }, 'getAllTrips', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.responseToTableData(res.data.data, self.cols).then(values => {
            self.trips = values;
            const count = self.trips.length;
            for(let i=0; i<count;i++){
              self.trips[i].trip_date= moment(self.trips[i].date_start).format('DD MMM YYYY') + ' - ' + moment(self.trips[i].date_end).format('DD MMM YYYY')
            }
          })
        }
        self.options.isUploading = false;
        self.isLoaded = true;
      });
    },
    async getCurrentUser() {
      let self = this;
      await this.doPost({userdata: self.options.user, data: self.options.user.id}, 'getUserById', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data; 
          self.setNewUserOptions(result);
        }})
    },
    setNewUserOptions(result){
      this.options.user.brandings = result.brandings;
    },
    async autoLaunchImport() {
      // --- Legacy flow (unchanged) ---
      const importId = sessionStorage.getItem('autoImportId');
      if (importId) {
        this.options.currentTrip = {
          nezasa_id: importId,
          sales_firstname: this.options.user.firstname,
          sales_lastname: this.options.user.lastname,
          sales_user_id: this.options.user.id,
          autoImport: true
        };
        this.options.showImportTripForm = true;
        return;
      }

      // --- New /nezasaimport flow ---
      const nezasaId = localStorage.getItem('nezasa_id_for_import');
      const autoImport = localStorage.getItem('nezasa_autoimport');
      const autoImportDate = localStorage.getItem('nezasa_autoimport_date');

      // Clean up immediately (prevent re-trigger on refresh)
      localStorage.removeItem('nezasa_id_for_import');
      localStorage.removeItem('nezasa_autoimport');
      localStorage.removeItem('nezasa_autoimport_date');

      if (!nezasaId || autoImport !== 'true') return;

      // Re-validate ID (defense in depth)
      const sanitizedId = String(nezasaId).toLowerCase().replace(/\s/g, '');
      if (!/^[a-z0-9]{12}$/.test(sanitizedId)) return;

      // Check 1-hour expiry
      const timestamp = parseInt(autoImportDate, 10);
      if (isNaN(timestamp) || Date.now() - timestamp > 3600000) return;

      // Ensure brandings are loaded
      await this.getAllBrandings();

      // Check if trip already exists and fetch mitarbeiter, then show confirm modal
      const self = this;
      this.doPost({data: sanitizedId}, 'getPublicTripById', res => {
        if (res.data.status === 'error' || res.data.status === 400) return;

        const tripExists = res.data.data && res.data.data.length > 0;

        // Fetch mitarbeiter list for the dropdown
        const showModal = function (mitarbeiterList) {
          const brands = self.matchedBrand || [];
          const selectedBranding = brands.length ? String(brands[0].brandingID) : '';
          const selectedMitarbeiter = self.options.user.id;

          const isReimport = tripExists;
          const title = isReimport
            ? (self.options.Lang?.Vorgang_reimportieren || 'Re-import process')
            : (self.options.Lang?.Neuen_Vorgang_importieren || 'Import new process');
          const message = '';
          const btnText = isReimport
            ? (self.options.Lang?.Vorgang_neu_importieren || 'Import new process')
            : (self.options.Lang?.Vorgang_importieren || 'Import process');

          Object.assign(self.options.globalConfirm, {
            visible: true,
            styled: true,
            title: title,
            message: message,
            confirmBtnText: btnText,
            nezasaId: sanitizedId,
            brands: brands,
            mitarbeiter: mitarbeiterList,
            selectedBranding: selectedBranding,
            selectedMitarbeiter: selectedMitarbeiter,
            onConfirm: () => {
              // Find selected employee name
              const selectedEmployee = mitarbeiterList.find(m => m.id === self.options.globalConfirm.selectedMitarbeiter);
              const salesFirstname = selectedEmployee ? selectedEmployee.firstname : self.options.user.firstname;
              const salesLastname = selectedEmployee ? selectedEmployee.lastname : self.options.user.lastname;
              // Find selected branding name
              const selectedBrand = brands.find(b => String(b.brandingID) === self.options.globalConfirm.selectedBranding);

              self.options.globalConfirm.visible = false;
              self.options.currentTrip = {
                nezasa_id: sanitizedId,
                sales_firstname: salesFirstname,
                sales_lastname: salesLastname,
                sales_user_id: selectedEmployee ? selectedEmployee.id : self.options.user.id,
                Branding: selectedBrand ? selectedBrand.name : undefined,
                autoImport: true,
                isReimport: isReimport
              };
              self.options.showImportTripForm = true;
            },
            onCancel: () => {
              self.options.globalConfirm.visible = false;
            }
          });
        };

        // Fetch mitarbeiter
        if (self.options.user.trips_isolated !== 1) {
          self.doPost({user: self.options.user}, 'getmyUsers', res2 => {
            if (res2.data.status === 'error') {
              showModal([{ id: self.options.user.id, firstname: self.options.user.firstname, lastname: self.options.user.lastname }]);
            } else {
              showModal(res2.data.data || []);
            }
          });
        } else {
          showModal([{ id: self.options.user.id, firstname: self.options.user.firstname, lastname: self.options.user.lastname }]);
        }
      });
    },
  }
};
</script>
<style>
  #alertBox{
    position: absolute;
    min-height: 5rem;
    max-height: 25rem;
    overflow-y: scroll;
    width: 60%;
    top: 15rem;
    left: 15%;
    background-color: white !important;
    z-index: +111111111;
  }
  @media screen and (max-width: 1401px) and (max-height: 1051px) {
    .md-table .md-table-cell-container{
      padding: 8px 4px !important;
    }
    .md-table .md-table-head-label{
      padding-left: 4px !important;
      padding-right: 4px !important;
    }
    .top-action-btn {
      font-size: 10px !important;
      width: 150px !important;
      margin: 2px !important;

    }

  }
</style>